module.exports = __webpack_public_path__ + "img/cs-icon.a30a7785.svg";